
	<div class="social">
		<div class="gutter flx-dynamic flx-gap-default flx-btwn-cntr">
			<div class="flx-dynamic flx-gap-default flx-cntr-cntr">
				<b i18n="@@contact_our_ppl">Skontaktuj się z naszymi doradcami</b>
				<a href="tel:{{ settings?.website_phone }}" class="icon-link">{{ settings?.website_phone }}</a>
				<p>{{ settings?.website_short_contact }}</p>
			</div>
			<div class="flx-row flx-gap-default flx-cntr-cntr">
				<a *ngIf="settings.facebook_use_profile" [href]="settings.facebook_key_profile" target="_blank"
				rel="noopener noreferrer"><span i18n="@@fb">Profil Facebook</span><svg class="icon icon-facebook-square">
				<use xlink:href="#icon-facebook-square"></use>
				</svg></a>
				<a *ngIf="settings.social_instagram_toggle" [href]="settings.social_instagram" target="_blank"
				rel="noopener noreferrer"><span i18n="@@insta">Profil Instagram</span><svg class="icon icon-instagram">
				<use xlink:href="#icon-instagram"></use>
				</svg></a>
				<a *ngIf="settings.social_twitter_toggle" [href]="settings.social_twitter" target="_blank"
				rel="noopener noreferrer"><span i18n="@@twitter">Profil Twitter</span><svg class="icon icon-twitter-square">
				<use xlink:href="#icon-twitter-square"></use>
				</svg></a>
				<a *ngIf="settings.social_vimeo_toggle" [href]="settings.social_vimeo" target="_blank"
				rel="noopener noreferrer"><span i18n="@@vimeo">Profil Vimeo</span><svg class="icon icon-vimeo-square">
				<use xlink:href="#icon-vimeo-square"></use>
				</svg></a>
				<a *ngIf="settings.social_pinterest_toggle" [href]="settings.social_pinterest" target="_blank"
				rel="noopener noreferrer"><span i18n="@@pinterest">Profil Pinterest</span><svg class="icon icon-pinterest-square">
				<use xlink:href="#icon-pinterest-square"></use>
				</svg></a>
			</div>
		</div>
	</div>

	<div class="gutter gutter-v">
		<ul *ngIf="navigation.length" class="flx-dynamic flx-cntr-strt">
			<li>
				<span i18n (click)="toggleChildren(-1)" [class.expanded]="mobilePath.includes(-1)" i18n="@@offer">OFERTA</span>
				<ul *ngIf="mobilePath.includes(-1) || !isMobile">
					<ng-container *ngFor="let page of navigationShop">
						<li *ngIf="allowed.includes(+page.visible)">
							<a *ngIf="page.module != 'container'" [routerLink]="[page?.path]">{{ page.name }}</a>
						</li>
					</ng-container>
				</ul>
			</li>

			<ng-template #recursiveList let-navigation>
				<ng-container *ngFor="let page of navigation">
					<li *ngIf="allowed.includes(+page.visible)">
						<span *ngIf="+page.children?.length > 0 || page.module == 'container'" (click)="toggleChildren(page.id)" [class.expanded]="mobilePath.includes(page.id)">{{ page.name }}</span>
						<a *ngIf="+page.children?.length == 0 && page.module != 'container'" [routerLink]="[page?.path]">{{ page.name }}</a>
						<ul *ngIf="(page.children && mobilePath.includes(page.id)) || (page.children && !isMobile)">
							<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: page.children }">
							</ng-container>
						</ul>
					</li>
				</ng-container>
			</ng-template>
			<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: navigation }"></ng-container>
		</ul>

	</div>

	<div class="copyright">
		<div class="gutter flx-row flx-btwn-cntr">
			<p class="siteinfo" i18n="@@copyright">Informacje zawarte na stronie internetowej nie są prawnie wiążące i nie stanowią oferty handlowej, w tym w rozumieniu art. 66 § 1 prawa cywilnego. Zdjęcie lub render produktu może odbiegać od jego rzeczywistego wyglądu i ten fakt nie może stanowić podstawy zgłoszenia reklamacyjnego.</p>
			<p>© {{ pageName }} 2024</p>
		</div>
	</div> 